module.exports = __webpack_public_path__ + "static/ed01fc0fb899a64a07ddccf4e30d7172b066ec0ef83f101fb7e792e559814143-23629147de4de8ecca116019223f2841.png";